import { Meta } from "../GameStream";

export class MockMeta implements Meta {
  public message = "message";
  public refreshIn?: number;
  public timeLeft?: number;
  public title?: string;
}
